import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';


const EmptyLayout = ({ children }) => {
  return (
  	<div className="empty-layout-wrapper">
	  <Container className="py-3" style={{ maxWidth: '1440px' }}>
		<Row className="justify-content-center g-2 w-100">
		  {children}
		  <Outlet />
		</Row>
	  </Container>
	</div>
  );
};

export default EmptyLayout;
